<script>
import { cn } from '@/lib/utils'

export default {
  name: 'UiLabel',
  inheritAttrs: false,
  props: {
    htmlFor: { type: String, default: null }
  },
  setup(props, { attrs }) {
    const getClass = () => {
      return cn(
        'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        attrs.class ?? ''
      )
    }

    return {
      getClass
    }
  }
}
</script>

<template>
  <label
    :for="htmlFor"
    :class="getClass()"
  >
    <slot></slot>
  </label>
</template>
